export const twoDigitsTime = time => `${time}`.padStart(2, '0');

export const timeFromNumber = (time) => Math.floor(time) === time
  ? twoDigitsTime(time) + ':00:00'
  : `${time}.00`.split('.').map( twoDigitsTime ).join(':');

export const numberFromTime = (time) => time.indexOf(':00:00') > 0
  ? parseInt(time.substr(0, 2), 10)
  : parseInt(time.split(':')[0], 10) + parseInt(time.split(':')[1], 10) / 100;
